import metadata from '../../bankrate-tracking/metadata'
import getPid, { getAttrPid } from './pid'
import { beamPageLoad } from '../../services/tagularEvent'
;(function() {
  beamPageLoad(
    'CookieIdentified',
    {
      key: 'pid_brmp',
      value: getPid()
    },
    'browser',
    'v1alpha'
  )

  beamPageLoad(
    'CookieIdentified',
    {
      key: 'pid_attr',
      value: getAttrPid()
    },
    'browser',
    'v1alpha'
  )

  const formatAttrList = attributeInput => {
    // Remove spaces before and after commas
    let attributeContent = attributeInput.split(/\s*(?:,|$)\s*/).join(',')
    // Replace spaces between words with underscores
    attributeContent = attributeContent
      .split(' ')
      .join('_')
      .toUpperCase()

    return attributeContent.split(',')
  }

  const createIsoDate = dateString => {
    if (!dateString) return

    let date = new Date(dateString)

    return date.toISOString()
  }

  const primaryCategory = metadata.getMetaData('Category') || ''
  const pageTitle = document.title
  const publishDate = document.head.querySelector('[name="Published"]')
  const publishDateISO = document.head.querySelector('[name="PublishedISO"]')
  const author = document.head.querySelector('[name="Author"]')
  const funnelStage = document.head.querySelector('[name="FunnelStage"]')
  const targetAudience = document.head.querySelector('[name="TargetPersona"]')
  const objective = document.head.querySelector('[name="Objective"]')
  const lastRefreshDate = document.head.querySelector('[name="Modified"]')
  const lastRefreshDateISO = document.head.querySelector('[name="ModifiedISO"]')
  let pageType = metadata.getMetaData('PageType') || ''
  let deviceType = ''
  let targetAudienceContent = targetAudience
    ? formatAttrList(targetAudience.getAttribute('content'))
    : null
  let objectiveContent = objective
    ? formatAttrList(objective.getAttribute('content'))
    : null
  let publishDateContent = null
  if (publishDateISO) {
    publishDateContent = createIsoDate(
      publishDateISO
        ? new Date(publishDateISO.getAttribute('content'))
        : publishDate
        ? new Date(publishDate.getAttribute('content'))
        : null
    )
  }
  let lastRefreshDateContent = null
  if (lastRefreshDateISO) {
    lastRefreshDateContent = createIsoDate(
      lastRefreshDateISO
        ? new Date(lastRefreshDateISO.getAttribute('content'))
        : lastRefreshDate
        ? new Date(lastRefreshDate.getAttribute('content'))
        : null
    )
  }

  if (window.pageTypeTagOverride) {
    pageType = window.pageTypeTagOverride
  }

  if (window.deviceTypeTagOverride) {
    deviceType = window.deviceTypeTagOverride
  }

  beamPageLoad(
    'ContentMetadataTracked',
    {
      contentName: pageTitle ? pageTitle : null,
      siteSection: deviceType,
      category: primaryCategory ? primaryCategory : null,
      tags: [pageType],
      publishDate: publishDateContent,
      author: author ? author.getAttribute('content') : null,
      funnelStage: funnelStage
        ? funnelStage.getAttribute('content').toUpperCase()
        : null,
      targetAudience: targetAudienceContent,
      objective: objectiveContent,
      lastRefreshDate: lastRefreshDateContent
    },
    'usertracking',
    'v4'
  )
})()
